import type { SelfHostConfig } from "./WebTransport";

/**
 * Cloud server remote config resolver.
 *
 * The legacy "Cloud Server" feature (dedicated UpCloud VMs registered as
 * type="cloud" servers) was removed when broadcast migrated to Cloudflare.
 * Desktop broadcast now composes locally (SHM) and pushes cloud destinations
 * to Cloudflare via Kero, so there is never a dedicated remote server to
 * resolve here. `resolve()` returns null without hitting any endpoint.
 */
class CloudRemote {
  private config: SelfHostConfig | null = null;

  async resolve(): Promise<SelfHostConfig | null> {
    return null;
  }

  getConfig(): SelfHostConfig | null {
    return this.config;
  }
}

export default CloudRemote;
